export const getActivityIndex = (): string => {
  const { search } = window.location;
  const params = new URLSearchParams(search);
  const index = String(params.get('a') || '');
  return index;
};
